// Active on click styling
jQuery(document).ready(function ($){
    $(".pagnation-menu li").each(function () {
        $(this).on("click", function () {
          $('.pagnation-menu li').removeClass('active');
          $(this).addClass('active');
        });
    });
});